<template>

    <div class="bodyComponente">
        <div class="cardsWrapper">
            <card-status texto-header="MMI" :texto-card="statusMessageMmi" :is-erro="mmiCheck.statusCode !== 200"
                texto-card-class="textoCardClassProps"
				:texto-footer="`${mmiCheck.requestTime !== null && mmiCheck.requestTime !== undefined ? mmiCheck.requestTime : 0} ms`" />
            <card-status texto-header="OEE" :texto-card="statusMessageOee"  :is-erro="oeeCheck.statusCode !== 200"
                texto-card-class="textoCardClassProps" :texto-footer="`${oeeCheck.requestTime !== null && oeeCheck.requestTime !== undefined ? oeeCheck.requestTime : 0} ms`" />
            <card-status texto-header="Alarmes" :texto-card="statusMessageAlarmes"  :is-erro="alarmesCheck.statusCode !== 200"
                texto-card-class="textoCardClassProps" :texto-footer="`${alarmesCheck.requestTime !== null && alarmesCheck.requestTime !== undefined ? alarmesCheck.requestTime : 0} ms`"/>
            <card-status texto-header="Mapas" :texto-card="statusMessageMapas"  :is-erro="mapasCheck.statusCode !== 200"
                texto-card-class="textoCardClassProps" :texto-footer="`${mapasCheck.requestTime !== null && mapasCheck.requestTime !== undefined ? mapasCheck.requestTime : 0} ms`"/>
            <card-status texto-header="ARMP" :texto-card="statusMessageArmp"  :is-erro="armpCheck.statusCode !== 200"
                texto-card-class="textoCardClassProps" :texto-footer="`${armpCheck.requestTime !== null && armpCheck.requestTime !== undefined ? armpCheck.requestTime : 0} ms`"/>
        </div>
    </div>

</template>


<script>
	import CardStatus from "../components/CardStatus.vue";
	import { FetchMmiTimestamp, FetchOeeTimestamp, FetchMapasTimestamp, FetchArmpTimestamp, FetchAlarmesTimestamp } from "../services/modules";

	export default {
		name: "ModulesPage",
		components: {
			CardStatus
		},
		data () {
			return {
				mmiCheck: { statusCode: 418 },
				oeeCheck: { statusCode: 418 },
				alarmesCheck: { statusCode: 418 },
				mapasCheck: { statusCode: 418 },
				armpCheck: { statusCode: 418 },
				globalErro: false
			};
		},
		computed: {

			statusMessageMmi () {
				if (this.mmiCheck.statusCode === 200) return "Online";
				if (this.mmiCheck.statusCode === 418) return "Offline";
				return "Api desconectada";
			},
			statusMessageOee () {
				if (this.oeeCheck.statusCode === 200) return "Online";
				if (this.oeeCheck.statusCode === 418) return "Offline";
				return "Api desconectada";
			},
			statusMessageAlarmes () {
				if (this.alarmesCheck.statusCode === 200) return "Online";
				if (this.alarmesCheck.statusCode === 418) return "Offline";
				return "Api desconectada";
			},
			statusMessageMapas () {
				if (this.mapasCheck.statusCode === 200) return "Online";
				if (this.mapasCheck.statusCode === 418) return "Offline";
				return "Api desconectada";
			},
			statusMessageArmp () {
				if (this.armpCheck.statusCode === 200) return "Online";
				if (this.armpCheck.statusCode === 418) return "Offline";
				return "Api desconectada";
			}
		},
		methods: {
			async MmiDashboard () {
				const data = await FetchMmiTimestamp();
				this.mmiCheck = data;
			},
			async OeeDashboard () {
				const data = await FetchOeeTimestamp();
				this.oeeCheck = data;
			},
			async AlarmesDashboard () {
				const data = await FetchAlarmesTimestamp();
				this.alarmesCheck = data;
			},
			async MapasDashboard () {
				const data = await FetchMapasTimestamp();
				this.mapasCheck = data;
			},
			async ArmpDashboard () {
				const data = await FetchArmpTimestamp();
				this.armpCheck = data;
			}

		},
		mounted () {
			this.MmiDashboard();
			this.OeeDashboard();
			this.AlarmesDashboard();
			this.MapasDashboard();
			this.ArmpDashboard();

			this.refresh = setInterval(() => {
				this.MmiDashboard();
				this.OeeDashboard();
				this.AlarmesDashboard();
				this.MapasDashboard();
				this.ArmpDashboard();
			}, 30000);
		},
		beforeDestroy () {
			clearInterval(this.refresh);
		}
	};
</script>


<style scoped>
:deep(.textoCardClassProps) {
    font-size: 11px;
}

.bodyComponente {
    width: calc(100% - 70px);
    margin-left: 70px;
    padding: 3rem 2rem;
    box-sizing: border-box;
}

.cardsWrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, 280px);
    gap: 3rem;
    max-width: 1100px;
    margin: 0 auto;
    justify-content: center;
}

.cardsWrapper>* {
    flex: 0 0 280px;
    max-width: 280px;


}
</style>